/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import { Behavior } from 'backbone.marionette';

import callByNeed from '../util/callByNeed';

const RadioGroupToggleBehavior = Behavior.extend({
  onRender() {
    const radios = callByNeed(this.options.radios, this.view);
    if (!_.isArray(radios)) {
      return;
    }
    radios.forEach((radio) => {
      this.$(radio.radioGroup).on('change', () => {
        this.handleTargetDisplay(radio);
      });
      this.handleTargetDisplay(radio);
    });
  },

  handleTargetDisplay(radio) {
    const currentRadioValue = this.$(`${radio.radioGroup}:checked`).val();
    if (currentRadioValue === radio.valueToShow) {
      this.$(radio.target).show();
      this.$(radio.target).removeAttr('disabled');
    } else {
      this.$(radio.target).hide();
      this.$(radio.target).attr('disabled', '');
    }
  },
});

export default RadioGroupToggleBehavior;
